export default __webpack_public_path__ + "static/broderie14.mobile.inspirations-2ce5144f23a25ca1b6ec2f66f1c330d5.jpg";